import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import { Button } from 'react-bootstrap';
import BlockedSeatModal from './BlockedSeatModal';
import BlockedSeatTable from './BlockedSeatTable';

import { openBlockedSeatModal, setBlockedSeats, clearBlockedSeats } from './actions';

import style from './style.module.scss';

const BlockedSeats = ({
  event,
  blockedSeats,
  openBlockedSeatModalAction,
  setBlockedSeatsAction,
  clearBlockedSeatsAction,
}) => {
  useEffect(() => {
    if (event) {
      setBlockedSeatsAction(event.blockedSeats);
    }
  }, [event]);

  if (isEmpty(event)) {
    return null;
  }

  return (
    <div className={style.blockedSeatsContainer}>
      <div className={style.blockedSeatsActionBar}>
        <h2>Blocked seats</h2>
        <div className={style.blockedSeatsActions}>
          <Button
            className="small"
            variant="outline-danger"
            onClick={clearBlockedSeatsAction}
            disabled={isEmpty(blockedSeats)}
          >
            Clear all
          </Button>
          <Button className="small" variant="outline-primary" onClick={openBlockedSeatModalAction}>
            Add block
          </Button>
        </div>
      </div>
      <BlockedSeatTable />
      <BlockedSeatModal />
    </div>
  );
};

export default connect(
  ({ events: { selectedEvents }, blockedSeats: { blockedSeats } }) => ({
    event: selectedEvents[0],
    blockedSeats,
  }),
  {
    openBlockedSeatModalAction: openBlockedSeatModal,
    setBlockedSeatsAction: setBlockedSeats,
    clearBlockedSeatsAction: clearBlockedSeats,
  },
)(BlockedSeats);
